import Prompt from './prompt'

export default Prompt;
